module.exports = __webpack_public_path__ + "img/simplex.c8583422.png";